/**
 * Lista gradova/naseljenih mjesta u BiH za prikaz korisniku.
 * Namenjeno da bude “ljudska” lista (bez tehničkih sufiksa tipa RS/FBiH, bez gradskih općina Sarajeva).
 */
export const CITIES_BIH: string[] = [
  "Banja Luka",
  "Banovići",
  "Berkovići",
  "Bileća",
  "Bihać",
  "Bijeljina",
  "Bratunac",
  "Breza",
  "Brčko",
  "Bosanska Krupa",
  "Bosanski Petrovac",
  "Bosansko Grahovo",
  "Brod",
  "Bužim",
  "Busovača",
  "Bugojno",
  "Cazin",
  "Čajniče",
  "Čapljina",
  "Čelić",
  "Čelinac",
  "Čitluk",
  "Derventa",
  "Doboj",
  "Doboj Istok",
  "Doboj Jug",
  "Dobretići",
  "Domaljevac-Šamac",
  "Donji Vakuf",
  "Donji Žabar",
  "Drvar",
  "Foča",
  "Fojnica",
  "Gacko",
  "Glamoč",
  "Goražde",
  "Gornji Vakuf-Uskoplje",
  "Gradiška",
  "Gradačac",
  "Gračanica",
  "Grude",
  "Hadžići",
  "Han-Pijesak",
  "Ilidža",
  "Ilijaš",
  "Jablanica",
  "Jajce",
  "Jezero",
  "Kakanj",
  "Kalesija",
  "Kalinovik",
  "Kiseljak",
  "Kladanj",
  "Ključ",
  "Kneževo",
  "Konjic",
  "Kostajnica",
  "Kotor-Varoš",
  "Kozarska Dubica",
  "Kreševo",
  "Krupa na Uni",
  "Kupres",
  "Laktaši",
  "Livno",
  "Lopare",
  "Ljubinje",
  "Ljubuški",
  "Lukavac",
  "Maglaj",
  "Milići",
  "Modriča",
  "Mostar",
  "Mrkonjić Grad",
  "Neum",
  "Nevesinje",
  "Novi Grad",
  "Novi Travnik",
  "Odžak",
  "Olovo",
  "Orašje",
  "Osmaci",
  "Oštra Luka",
  "Pale",
  "Pelagićevo",
  "Petrovac",
  "Petrovo",
  "Posušje",
  "Prijedor",
  "Prnjavor",
  "Prozor-Rama",
  "Ravno",
  "Ribnik",
  "Rogatica",
  "Rudo",
  "Sanski Most",
  "Sapna",
  "Sarajevo",
  "Sokolac",
  "Srbac",
  "Srebrenica",
  "Srebrenik",
  "Stanari",
  "Stolac",
  "Šamac",
  "Šekovići",
  "Šipovo",
  "Široki Brijeg",
  "Teočak",
  "Tešanj",
  "Teslić",
  "Tomislavgrad",
  "Travnik",
  "Trebinje",
  "Trnovo (FBiH)",
  "Trnovo (RS)",
  "Tuzla",
  "Ugljevik",
  "Usora",
  "Vareš",
  "Velika Kladuša",
  "Višegrad",
  "Visoko",
  "Vitez",
  "Vlasenica",
  "Vogošća",
  "Vukosavlje",
  "Zavidovići",
  "Zenica",
  "Žepče",
  "Živinice",
  "Zvornik",
].sort((a, b) => a.localeCompare(b, "hr"));
